import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AvatarUpload from './AvatarUpload';
import defaultAvatar from '../../../images/default_dealer.png';

class AvatarUploadContainer extends PureComponent {
  onFileSelect = (e) => {
    e.preventDefault();
    const { input, acceptedTypes, maxSize } = this.props;
    const file = e.target.files[0];
    const reader = new window.FileReader();

    reader.onloadend = () => {
      input.onChange(reader.result);
    };
    if (file && (!maxSize || file.size <= maxSize) && acceptedTypes.includes(file.type)) {
      e.target.value = null;
      reader.readAsDataURL(file);
    }
  };

  onFileRemove = () => {
    const { input } = this.props;
    input.onChange('');
  };

  render() {
    const { input: { value, name }, acceptedTypes } = this.props;
    return (
      <AvatarUpload
        name={name}
        avatarSrc={value || defaultAvatar}
        onFileSelect={this.onFileSelect}
        onFileRemove={this.onFileRemove}
        acceptedTypes={acceptedTypes}
      />
    );
  }
}

AvatarUploadContainer.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
  maxSize: PropTypes.number,
};

AvatarUploadContainer.defaultProps = {
  acceptedTypes: [],
  maxSize: null,
};

export default AvatarUploadContainer;
